import { render, staticRenderFns } from "./IngredientSearch.vue?vue&type=template&id=2dbcd746&"
import script from "./IngredientSearch.vue?vue&type=script&lang=js&"
export * from "./IngredientSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports